import { PDKDeleteIcon } from '@/components/ui/pdk-icons';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { toast } from '@/hooks/use-toast';
import { Circle, CircleCheck } from 'lucide-react';

const DealAssignedTasks = () => {
  const assignedTasks: {
    id: string;
    title: string;
    description: string;
    status: 'incomplete' | 'done';
  }[] = [];

  return (
    <div className="flex flex-col gap-1 px-2">
      <div>
        {assignedTasks.map((task, index) => (
          <div
            key={task.id + index}
            className="flex flex-row gap-2 text-ellipsis text-nowrap items-center justify-between"
          >
            <div className="flex flex-row gap-2 items-center">
              <div>
                {task.status === 'incomplete' ? (
                  <Circle
                    className="h-3.5 w-3.5 text-gray-500 cursor-pointer"
                    onClick={() => {
                      toast({
                        title: 'Feature not implemented yet',
                        description:
                          "Slack us if you want the 'trade-in appraisal set task to done' feature",
                      });
                      // setTaskToDone(task.id);
                    }}
                  />
                ) : (
                  <CircleCheck
                    className="h-3.5 w-3.5 text-green-500 cursor-pointer"
                    onClick={() => {
                      toast({
                        title: 'Feature not implemented yet',
                        description:
                          "Slack us if you want the 'trade-in appraisal set task to incomplete' feature",
                      });
                      // setTaskToIncomplete(task.id);
                    }}
                  />
                )}
              </div>
              <div>
                <Tooltip delayDuration={500}>
                  <TooltipTrigger>{task.title}</TooltipTrigger>
                  <TooltipContent>{task.description}</TooltipContent>
                </Tooltip>
              </div>
            </div>
            <div
              onClick={() => {
                toast({
                  title: 'Feature not implemented yet',
                  description:
                    "Slack us if you want the 'trade-in appraisal unassign task' feature",
                });
                // unassignTask(task.id);
              }}
            >
              <PDKDeleteIcon className="h-3.5 w-3.5 text-gray-500 cursor-pointer" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DealAssignedTasks;
